export const CHANGE_TYPE = {
	NEW: 'NEW',
	DELETED: 'DELETED',
	CHANGED: 'CHANGED',
	MOVED: 'MOVED',
	NO_CHANGE: 'NO_CHANGE'
};

export const DEFAULT_SELECTED_OPTION = {
	'NEW': 'REMOTE',
	'DELETED': 'DELETE',
	'CHANGED': 'REMOTE',
	'NO_CHANGE': 'LOCAL',
	'MOVED': 'REMOTE'
};

export const APPLY_LOCAL_REMOTE_MAPPING = {
	'LOCAL': {
		'NEW': 'LOCAL',
		'DELETED': 'LOCAL',
		'CHANGED': 'LOCAL',
		'MOVED': 'LOCAL'
	},
	'REMOTE': {
		'NEW': 'REMOTE',
		'DELETED': 'DELETE',
		'CHANGED': 'REMOTE',
		'MOVED': 'REMOTE'
	},
	'MERGE_LOCAL': {
		'NEW': 'LOCAL',
		'DELETED': 'LOCAL',
		'CHANGED': 'MERGE_LOCAL',
		'NO_CHANGE': 'LOCAL',
		'MOVED': 'LOCAL'
	},
	'MERGE_REMOTE': {
		'NEW': 'REMOTE',
		'DELETED': 'DELETE',
		'CHANGED': 'MERGE_REMOTE',
		'MOVED': 'REMOTE'
	}
};

export const META_FILE_EXTENSION = '.meta.js';
export const FILE_EXTENSION = '.js';